// Do we determine this point to be a small node? 
const isSmallProjectedNode = (index) => { 
    return isProjectedYear(index); 
} 
export default isSmallProjectedNode; 

export const smallThreshold = 50;
 
// Does the index belong to a projected year? 
export const isProjectedYear = (index) => index >= 2; 
 
// Is the school small? 
// Determined by the first projected year being <= 50; 
export const isSchoolSmall = school => isSmallValue(school.projections[2]); 

export const isSmallValue = v => v <= smallThreshold;


// WEBPACK FOOTER //
// ./src/components/singleClusterProjectionsLineGraph/isSmallProjectedNode.js